import API from '@/lib/api'
import { pick } from 'lodash'

const { createAsyncThunk } = require('@reduxjs/toolkit')

export const createOrder = createAsyncThunk('checkout/createOrder', async (payload, { rejectWithValue, getState }) => {
  const { cart, paymentMethod } = getState().checkout

  const data = {
    items: cart.map(o => pick({ ...o, additions: o.activeAdditions }, ['id', 'additions', 'quantity'])),
    paymentType: paymentMethod,
    takeout: false
  }

  return API.createOrder(data)
    .then(response => {
      console.log('[API] createOrder', response)
      return response.data
    })
    .catch(error => {
      console.error('[API] createOrder', error)
      return rejectWithValue(error.message)
    })
})
